// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4763bc16","176":"443fc7fb","178":"2a22453a","487":"ed2eb4ee","787":"c5c736cb","939":"88a87544","958":"2a4c066d","988":"d7e9bf7a"}[chunkId] + ".chunk.js";
};